import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { CashFlow } from './CashFlow';

@supertypeClass({ toClient: true, toServer: true })
export class Expense extends CashFlow {
  constructor() {
    super();
  }

  static new(customer, subtype?, amount?, title?) {
    return new Expense().init(customer, subtype, amount, title);
  }

  init(customer, subtype?, amount?, title?) {
    super.init(customer, 'expense', subtype, amount ? 0 - amount : 0, title);
    return this;
  }

  getAmount(flow, year, _deceased, yearOfDeath) {
    if (year < yearOfDeath) {
      return 0;
    }

    return 0 - (year >= flow.startYear && year <= flow.endYear ? flow.amount : 0);
  }

  adjustFlow(flow) {
    flow.amount += flow.amount * this.customer.settings.inflation;
  }
}
